<template>
  <div>
    <h2 v-text="formatDate(monthDate, formatDateHeadline)"></h2>
    <div class="event-days">
      <event-day
        class="event-day"
        v-for="day in days"
        :key="day.date.toString()"
        :dayDate="day.date"
        :events="day.events"
      ></event-day>
    </div>
  </div>
</template>

<script>
import EventMixin from '../mixins/EventMixin';
import EventDay from './event-day.vue';

export default {
  name: 'EventMonth',
  components: {
    EventDay,
  },
  props: {
    monthDate: Object,
    days: Array,
  },
  inject: ['formatDateHeadline'],
  mixins: [EventMixin],
};
</script>

<style lang="scss">
.event-days {
  padding: 0 27px;
  &:last-child {
    padding-bottom: 20px;
  }
}
</style>
